import type { CanMarkSessionsApi } from "@/Modules/Models/Api/Sessions";
import type { CreateSessionPayload } from "@/Modules/Models/Domain/Sessions";
import type {
  RefundSessionApiQuery,
  SessionsApi,
  SessionApiQuery,
  SessionCreateApiQuery,
} from "@/Modules/Models/Api/Sessions";

import { get2, post2, remove2 } from "./utils/FunctionalTherapyApi";

export const getSessions = (customerUuid: string): Promise<SessionsApi> => {
  return get2<SessionApiQuery, SessionsApi>("v1.0/subscriptions/sessions", {
    user_uuid: customerUuid,
  });
};

export const createSession = (payload: CreateSessionPayload): Promise<void> => {
  return post2<SessionCreateApiQuery, void>("v1.0/subscriptions/sessions", {
    user_uuid: payload.userUuid,
    attended_at: payload.attendedAt,
    type: payload.type,
    reason: payload.reason,
    comment: payload.comment,
  });
};

export const refundSessions = (customerUuid: string, sessionData: RefundSessionApiQuery): Promise<void> => {
  return post2<RefundSessionApiQuery, void>(
    `v2.0/subscriptions/sessions/${customerUuid}/refund`,
    sessionData
  );
};

export const deleteSession = (sessionUuid: string): Promise<void> => {
  return remove2<void, void>(`v1.0/subscriptions/sessions/${sessionUuid}`);
};

export const checkIsSessionRegister = (customerUuid: string): Promise<CanMarkSessionsApi> => {
  return get2<void, CanMarkSessionsApi>(`v1.0/subscriptions/sessions/${customerUuid}/check`);
};
